import { frontendURL } from 'dashboard/helper/URLHelper';
import PropostasIndex from './Index.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/propostas'),
    name: 'propostas_index',
    component: PropostasIndex,
    meta: {
      permissions: [
        'administrator', 'supervisor', 'agent', 'operacional',
        'qualidade', 'ouvidoria', 'juridico', 'custom_role',
      ],
    },
  },
];

export default { routes };
